import { z } from "zod";
// ===== REQUEST SCHEMAS =====
export const CreateUnplannedShiftRequestSchema = z.object({
    locationId: z.uuid(),
    jobRoleFamilyId: z.uuid(),
    notes: z.string().min(1).max(500),
});
// ===== RESPONSE SCHEMAS =====
export const UnplannedShiftResponseSchema = z.object({
    shift: z.object({
        id: z.uuid(),
        startTime: z.iso.datetime(),
        endTime: z.iso.datetime(),
        locationId: z.uuid(),
        jobRoleFamilyId: z.uuid(),
        isUnplanned: z.boolean(),
    }),
    timecard: z.object({
        id: z.uuid(),
        status: z.string(),
    }),
    approvalRequestId: z.uuid(),
});
